import _ from 'lodash';

const axios = require('axios');
require('es6-promise').polyfill();
const CONSTANTS = require('./platform/constants').default;
const ERRORS = require('./platform/errors').default;
const params = require('./params');

const defaultNode = CONSTANTS.defaultinventoryAndDealersNode;

function fetchDetails(query) {
  return axios.get(query)
    .then((response) => response.data);
}

function mapPackages(filters, modelPackages) {
  const packages = [];
  const rawPackageFilters = _.find(filters,
    { NavigationCategory: CONSTANTS.navigationPackages });
  const rawFeaturesFilters = _.find(filters,
    { NavigationCategory: CONSTANTS.navigationPremiumFeatures });
  const filterInfo = rawPackageFilters || rawFeaturesFilters;

  if (filterInfo && modelPackages.length > 0) {
    modelPackages.forEach((pkg) => {
      const pkgInfo = _.find(filterInfo.NavigationItems, { Id: pkg });
      if (pkgInfo.Name) {
        packages.push(pkgInfo.Name);
      }
    });
  }

  return packages;
}

function mapPowertrain(filters, modelPowertrain) {
  let rawEngineFilters = null;
  let rawDrivetrainFilters = null;
  let filterInfo = [];
  let powertrains = [];
  const rawPowertrainFilters = _.find(filters,
    { NavigationCategory: CONSTANTS.navigationPowertrainAcura });

  if (rawPowertrainFilters) { // Checking if Acura powertrain structure
    rawEngineFilters = _.find(rawPowertrainFilters.NavigationSections,
      { NavigationCategory: CONSTANTS.navigationEngine });
    rawDrivetrainFilters = _.find(rawPowertrainFilters.NavigationSections,
      { NavigationCategory: CONSTANTS.navigationDrivetrain });

    if (rawEngineFilters && rawEngineFilters.NavigationItems
        && rawDrivetrainFilters && rawDrivetrainFilters.NavigationItems) {
      filterInfo = rawEngineFilters.NavigationItems.concat(rawDrivetrainFilters.NavigationItems);
    }
  } else { // Honda simple structure
    rawEngineFilters = _.find(filters,
      { NavigationCategory: CONSTANTS.navigationPowertrainAutos });
    if (rawEngineFilters && rawEngineFilters.NavigationItems) {
      filterInfo = rawEngineFilters.NavigationItems;
    }
  }

  if (filterInfo.length > 0 && modelPowertrain.length > 0) {
    modelPowertrain.forEach((pw) => {
      const pwInfo = _.find(filterInfo, { Id: pw });
      if (rawPowertrainFilters) { // Checking if Acura structure to use Name
        if (pwInfo.Name) {
          powertrains.push(pwInfo.Name);
        }
      } else if (pwInfo.OptionDescription) { // Checking if Honda structure to use OptionDescription
        powertrains.push(pwInfo.OptionDescription);
      }
    });
  }

  if (powertrains.length === 0) {
    powertrains = null;
  }

  return powertrains;
}

function mapColors(filters, modelExterior, modelInterior, fabrictype) {
  let fabrictypeSearch = '';
  const colors = {
    exterior: null,
    interior: null,
  };
  let rawExteriorColorFilters = null;
  let rawInteriorColorFilters = null;
  // Checking Acura Structure
  const rawAppearanceFilters = _.find(filters,
    { NavigationCategory: CONSTANTS.navigationAppearance });

  if (rawAppearanceFilters) {
    // Using Acura Structure
    rawExteriorColorFilters = _.find(rawAppearanceFilters.NavigationSections,
      { NavigationCategory: CONSTANTS.navigationExteriorColorsAcura });
    rawInteriorColorFilters = _.find(rawAppearanceFilters.NavigationSections,
      { NavigationCategory: CONSTANTS.navigationInteriorColorsAcura });
  } else {
    // ST-2041 Handling old structure for Honda
    rawExteriorColorFilters = _.find(filters,
      { NavigationCategory: CONSTANTS.navigationExteriorColorsAutos });
    rawInteriorColorFilters = _.find(filters,
      { NavigationCategory: CONSTANTS.navigationInteriorColorsAutos });
  }

  if (rawExteriorColorFilters.NavigationItems) {
    const ext = _.find(rawExteriorColorFilters.NavigationItems, { ColorMfgCode: modelExterior });
    colors.exterior = ext;
    if (!ext) {
      window.console.warn(ERRORS.vehicleData.noExteriorColor);
    }
  }

  if (rawInteriorColorFilters.NavigationItems) {
    if (fabrictype) {
      fabrictypeSearch = fabrictype;
    }
    const int = _.find(rawInteriorColorFilters.NavigationItems,
      { ColorCode: modelInterior, FabricType: fabrictypeSearch });
    colors.interior = int;
    if (!int) {
      window.console.warn(ERRORS.vehicleData.noInteriorColor);
    }
  }
  return colors;
}

// Adding the default image width for IRI images as a parameter
function processImages(images) {
  // TODO: In case BE implement a CMS value for the default width
  // we'll use it as window.raq.IRIWidth
  const width = window.raq && window.raq.IRIWidth ? window.raq.IRIWidth : 500;
  const imageType = 'png';
  const results = [];
  if (!images) {
    return null;
  }
  images.forEach((img) => {
    results.push(`${img}&width=${width}&filetype=${imageType}`);
  });
  return results;
}

function mapDetails(data) {
  const modelId = data.inventory[defaultNode].ModelId;
  const model = data.models && data.models[modelId] ? data.models[modelId] : false;
  if (!model) {
    window.console.warn(ERRORS.vehicleData.noModelsNode);
  }
  const exteriorColorCode = data.inventory[defaultNode].ExteriorColorMfgCode;
  const interiorColorCode = data.inventory[defaultNode].InteriorColorCode;
  return {
    colors: mapColors(data.filters, exteriorColorCode, interiorColorCode, model.FabricType),
    images: processImages(model.VehiclePhotos[exteriorColorCode][interiorColorCode]),
    modelId,
    name: data.inventory[defaultNode].ModelGroupName,
    MSRP: data.inventory[defaultNode].ModelMSRP,
    msrpDisclaimer: data.msrpdisclaimer,
    disclaimers: data.disclaimers,
    year: data.inventory[defaultNode].ModelYear,
    inTransitCount: data.inventory[defaultNode].NumberInTransit,
    onLotCount: data.inventory[defaultNode].NumberOnSite,
    dealerName: data.dealers[defaultNode].Name,
    packages: model.Packages ? mapPackages(data.filters, model.Packages) : null,
    powertrains: model.Powertrain ? mapPowertrain(data.filters, model.Powertrain) : null,
    transmission: model.ModelHighlightFeature,
    trim: model.TrimGroup,
    modelmarketingname: model.ModelMarketingName,
  };
}

function mapData(data) {
  const modelId = data.inventory[defaultNode].ModelId;
  const model = data.models && data.models[modelId] ? data.models[modelId] : false;
  if (!model) {
    window.console.warn(ERRORS.vehicleData.noModelsNode);
  }
  const exteriorColorCode = data.inventory[defaultNode].ExteriorColorMfgCode;
  const interiorColorCode = data.inventory[defaultNode].InteriorColorCode;
  return {
    colors: mapColors(data.filters, exteriorColorCode, interiorColorCode, model.FabricType),
    images: processImages(model.VehiclePhotos[exteriorColorCode][interiorColorCode]),
    modelId,
    name: data.inventory[defaultNode].ModelGroupName,
    year: data.inventory[defaultNode].ModelYear,
    packages: model.Packages ? mapPackages(data.filters, model.Packages) : null,
    powertrains: model.Powertrain ? mapPowertrain(data.filters, model.Powertrain) : null,
    transmission: model.ModelHighlightFeature,
    trim: model.TrimGroup,
    modelmarketingname: model.ModelMarketingName,
  };
}

function mapBasic(data) {
  const images = data.VehicleCardImage !== '' ? [data.VehicleCardImage] : null;
  let vehicle = null;
  if (data.VehicleModelSeriesName) {
    vehicle = {
      name: data.VehicleModelSeriesName,
      trim: data.VehicleModelSeriesName,
      modelmarketingname: data.VehicleModelSeriesName,
      year: data.ModelYear,
      images,
      imageDisclaimer: data.VehicleCardDisclaimer && data.VehicleCardDisclaimer.description
        ? data.VehicleCardDisclaimer.description : null,
    };
    if (!params.userData().carModelYear) {
      params.setVehicleYear(data.ModelYear);
    }
  } else {
    window.console.warn(ERRORS.noVehicleData, data);
  }
  return vehicle;
}

function getDetailsCard(query) {
  return fetchDetails(query)
    .then((data) => mapDetails(data));
}

function getDataCard(query) {
  return fetchDetails(query)
    .then((data) => mapData(data));
}

function getBasicCard(query) {
  return fetchDetails(query)
    .then((data) => mapBasic(data));
}

function getTaxonomy(query) {
  return fetchDetails(query)
    .then((data) => data);
}

const vehicle = {
  details: getDetailsCard,
  basic: getBasicCard,
  data: getDataCard,
  taxonomy: getTaxonomy,
};

module.exports = vehicle;
